var __jsx = React.createElement;
import DixuContainer from "../../components/DixuContainer/DixuContainer";
import { DixuCol, DixuRow } from "../../components/DixuGrid/DixuGrid";
import DixuImage from "../../components/DixuImage/DixuImage";
import DixuText from "../../components/DixuText/DixuText";
import DixuTitle from "../../components/DixuTitle/DixuTitle";
import { useTranslation } from "../../i18n";
import React from 'react';
import DixuLink from "../../components/DixuLink/DixuLink";
import DixuHead from "../../components/DixuHead/DixuHead";
import DixuButton from "../../components/DixuButton/DixuButton";
import ManThumbUpIcon from "../../public/decorative/man_thumb_up.svg";
import ApartmentBuildingIcon from "../../public/decorative/apartment_building.svg";
import FinlandMapIcon from "../../public/decorative/finland_map.svg";
import DixuEstSignIcon from "../../public/decorative/dixu_est_sign.svg";
import SellerManIcon from "../../public/decorative/seller_man.svg";
import RealtorWomanIcon from "../../public/decorative/realtor_woman.svg";
import KoodiaSuomesta from "../../public/icons/koodia_suomesta.svg";
import { toRem } from "../../utils/Utils";
const WhatIsDixuSection = () => {
  const {
    t
  } = useTranslation(['aboutus']);
  return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(DixuContainer, {
    maxWidth: "lg"
  }, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, {
      xs: 62,
      md: 138,
      xl: 74
    }]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuTitle.PageTitle, null, t('aboutus:WhatIsDixu.Title'))), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "center",
    align: "middle",
    gutter: [{
      xs: 40,
      xl: 48
    }, 26],
    wrap: "reverse"
  }, /*#__PURE__*/React.createElement(DixuCol, {
    flex: "1 1 50%"
  }, /*#__PURE__*/React.createElement(DixuTitle.PageTitle, {
    level: "2",
    subtitle: t('aboutus:WhatIsDixu.Content'),
    titleProps: {
      align: 'left'
    },
    subtitleProps: {
      align: 'left'
    },
    subtitleContainerProps: {
      maxWidth: null
    }
  }, t('aboutus:WhatIsDixu.Subtitle'))), /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuImage, {
    src: "/images/dixu_tablet_and_phone.png",
    width: "288",
    height: "260",
    fit: "scale-down"
  })))))));
};
const KeyPointsSection = () => {
  const {
    t
  } = useTranslation(['aboutus']);
  const smallItems = [{
    img: /*#__PURE__*/React.createElement(ManThumbUpIcon, {
      style: {
        width: toRem(150),
        height: toRem(150)
      }
    }),
    title: '4,7/5',
    subtitle: t('aboutus:KeyPoints.RecommendsDixuConcept')
  }, {
    img: /*#__PURE__*/React.createElement(ApartmentBuildingIcon, {
      style: {
        width: toRem(150),
        height: toRem(150)
      }
    }),
    title: '~ 5000',
    subtitle: t('aboutus:KeyPoints.PublishedListings')
  }, {
    img: /*#__PURE__*/React.createElement(FinlandMapIcon, {
      style: {
        width: toRem(150),
        height: toRem(150)
      }
    }),
    subtitle: t('aboutus:KeyPoints.OperatesWholeFinland')
  }, {
    img: /*#__PURE__*/React.createElement(DixuEstSignIcon, {
      style: {
        width: toRem(150),
        height: toRem(150)
      }
    }),
    title: '2018',
    subtitle: t('aboutus:KeyPoints.Founded'),
    subtitleFirst: true
  }].map(_ref => {
    let {
      img,
      title,
      subtitle,
      subtitleFirst
    } = _ref;
    const renderedTitle = /*#__PURE__*/React.createElement(React.Fragment, null, title && /*#__PURE__*/React.createElement(DixuText, {
      family: "ropa",
      transform: "uppercase",
      font: "7",
      color: "2-8",
      weight: "heavy",
      align: "center",
      block: true
    }, title));
    const renderedSubtitle = /*#__PURE__*/React.createElement(React.Fragment, null, subtitle && /*#__PURE__*/React.createElement(DixuText, {
      family: "ropa",
      transform: "uppercase",
      font: "4",
      color: "2-8",
      weight: "heavy",
      align: "center",
      whiteSpace: "pre-line",
      block: true
    }, subtitle));
    return /*#__PURE__*/React.createElement(DixuCol, {
      key: `${title}${subtitle}`,
      flex: "0 1 20%"
    }, /*#__PURE__*/React.createElement(DixuRow, {
      justify: "center",
      align: "middle",
      gutter: [0, 16]
    }, /*#__PURE__*/React.createElement(DixuCol, {
      span: 24
    }, /*#__PURE__*/React.createElement(DixuRow, {
      justify: "center"
    }, /*#__PURE__*/React.createElement(DixuCol, null, img))), /*#__PURE__*/React.createElement(DixuCol, {
      span: 24
    }, !subtitleFirst && renderedTitle, renderedSubtitle, subtitleFirst && renderedTitle)));
  });
  const largeItems = [{
    img: /*#__PURE__*/React.createElement(SellerManIcon, {
      style: {
        height: toRem(210),
        width: toRem(125)
      }
    }),
    title: '2 %',
    subtitle: t('aboutus:KeyPoints.SelfSellers')
  }, {
    img: /*#__PURE__*/React.createElement(RealtorWomanIcon, {
      style: {
        height: toRem(210),
        width: toRem(125)
      }
    }),
    title: '98 %',
    subtitle: t('aboutus:KeyPoints.RealtorsUsed')
  }].map((_ref2, index) => {
    let {
      img,
      title,
      subtitle
    } = _ref2;
    const odd = index % 2 === 1;
    const imageCol = /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuRow, {
      justify: "center"
    }, /*#__PURE__*/React.createElement(DixuCol, null, img)));
    const contentCol = /*#__PURE__*/React.createElement(DixuCol, null, subtitle && /*#__PURE__*/React.createElement(DixuText, {
      family: "ropa",
      transform: "uppercase",
      font: "5",
      color: "2-8",
      weight: "heavy",
      align: "left",
      whiteSpace: "pre-line",
      block: true
    }, subtitle), title && /*#__PURE__*/React.createElement(DixuText, {
      family: "ropa",
      transform: "uppercase",
      font: "9",
      color: "2-8",
      weight: "heavy",
      align: "left",
      block: true
    }, title));
    return /*#__PURE__*/React.createElement(DixuCol, {
      key: `${title}${subtitle}`,
      hxs: 24,
      md: 12
    }, /*#__PURE__*/React.createElement(DixuRow, null, odd && /*#__PURE__*/React.createElement(DixuCol, {
      xs: 24,
      md: 0
    }, /*#__PURE__*/React.createElement(DixuRow, {
      justify: "center",
      align: "middle",
      gutter: [32, 16],
      wrap: false
    }, contentCol, imageCol)), /*#__PURE__*/React.createElement(DixuCol, {
      xs: odd ? 0 : 24,
      md: 24
    }, /*#__PURE__*/React.createElement(DixuRow, {
      justify: "center",
      align: "middle",
      gutter: [32, 16],
      wrap: false
    }, imageCol, contentCol))));
  });
  return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(DixuContainer, {
    background: "2-3",
    verticalPadding: "xxxl"
  }, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "center"
  }, /*#__PURE__*/React.createElement(DixuCol, {
    xs: 20,
    md: 24,
    xl: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "center",
    gutter: [64, 64]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "center",
    gutter: [64, 64]
  }, smallItems)), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "center",
    gutter: [64, 64]
  }, largeItems)))))));
};
const MiscSection = () => {
  const {
    t
  } = useTranslation(['common', 'aboutus']);
  return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(DixuContainer, null, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, {
      xs: 24,
      md: 64
    }]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [40, {
      xs: 40,
      md: 80
    }]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    xl: 12
  }, /*#__PURE__*/React.createElement(DixuTitle, {
    level: "2",
    appear: "3",
    color: "2-8",
    weight: "bold",
    responsive: true
  }, t('aboutus:ForConsumers.Title')), /*#__PURE__*/React.createElement(DixuText, {
    font: "3",
    color: "2-8",
    weight: "medium"
  }, t('aboutus:ForConsumers.Content.Part1'), /*#__PURE__*/React.createElement(DixuLink, {
    href: "/hinnasto",
    weight: "bold"
  }, t('aboutus:ForConsumers.Content.Part2')))), /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    xl: 12
  }, /*#__PURE__*/React.createElement(DixuTitle, {
    level: "2",
    appear: "3",
    color: "2-8",
    weight: "bold",
    responsive: true
  }, t('aboutus:DixuForRealtors.Title')), /*#__PURE__*/React.createElement(DixuText, {
    font: "3",
    color: "2-8",
    weight: "medium"
  }, t('aboutus:DixuForRealtors.Content.Part1'), /*#__PURE__*/React.createElement(DixuLink, {
    href: "https://linear.fi/#services",
    weight: "bold",
    external: true
  }, t('aboutus:DixuForRealtors.Content.Part2')))), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    align: "middle",
    gutter: [40, {
      xs: 40,
      md: 80
    }]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    xl: 12
  }, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "center",
    align: "middle"
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 18
  }, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "center",
    align: "middle",
    gutter: [16, 16],
    wrap: false
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 12
  }, /*#__PURE__*/React.createElement(KoodiaSuomesta, null)))))), /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    xl: 12
  }, /*#__PURE__*/React.createElement(DixuTitle, {
    level: "2",
    appear: "2",
    color: "2-8",
    weight: "bold",
    responsive: true
  }, t('aboutus:DixuIsFinnish.Title')), /*#__PURE__*/React.createElement(DixuText, {
    font: "3",
    color: "2-8",
    weight: "medium"
  }, t('aboutus:DixuIsFinnish.Content'))))))), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "center"
  }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuButton, {
    href: "/ota-yhteytta",
    type: "primary",
    size: "lg",
    block: false
  }, t('common:Nav.ContactUs'))))))));
};
const DixuAboutUsScreen = () => {
  const {
    t
  } = useTranslation(['aboutus']);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DixuHead, {
    title: t('aboutus:Metadata.Title'),
    description: t('aboutus:Metadata.Description')
  }), /*#__PURE__*/React.createElement(WhatIsDixuSection, null), /*#__PURE__*/React.createElement(KeyPointsSection, null), /*#__PURE__*/React.createElement(MiscSection, null));
};
export default DixuAboutUsScreen;